var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header supports-backdrop-blur:bg-white/60 sticky top-0 z-[3001] w-full flex-none backdrop-blur transition",attrs:{"id":"main-header"}},[_c('div',{staticClass:"grid-container"},[_c('HeaderMenu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }